import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const FavoritesContext = createContext(null);

export function FavoritesProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);

  const refresh = useCallback(async () => {
    if (!user) {
      setIds([]);
      return;
    }
    try {
      const { data } = await api.get("/favorites");
      setIds(data.ids);
    } catch {
      setIds([]);
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const toggle = async (propertyId) => {
    if (!user) {
      toast.error("Sign in to shortlist properties");
      return;
    }
    const saved = ids.includes(propertyId);
    setIds(saved ? ids.filter((i) => i !== propertyId) : [...ids, propertyId]);
    try {
      if (saved) await api.delete(`/favorites/${propertyId}`);
      else await api.post(`/favorites/${propertyId}`);
      toast.success(saved ? "Removed from shortlist" : "Added to shortlist");
    } catch {
      refresh();
      toast.error("Could not update shortlist");
    }
  };

  return (
    <FavoritesContext.Provider value={{ ids, toggle, refresh, count: ids.length }}>
      {children}
    </FavoritesContext.Provider>
  );
}

export const useFavorites = () => useContext(FavoritesContext);
